(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rs-order-panel"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-compact-variant]');
  if (select) select.form.requestSubmit();
});
document.addEventListener('submit', (event) => {
  const form = event.target.closest('.rs-order__destination');
  if (!form) return;
  const quantity = document.getElementById(form.dataset.quantitySource);
  if (quantity && quantity.checkValidity()) form.elements.quantity.value = quantity.value;
});
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-quote-quantity]');
  if (!link) return;
  const quantity = document.getElementById(link.dataset.quoteQuantity);
  if (quantity && !quantity.reportValidity()) { event.preventDefault(); return; }
  if (quantity && quantity.checkValidity()) {
    const url = new URL(link.href);
    url.searchParams.set('quantity', quantity.value);
    link.href = url.href;
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rs-pdp-layout"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{
 const root=event.target.closest('.rsbp');
 if(!root)return;
 const thumb=event.target.closest('[data-rsbp-thumb]');
 const step=event.target.closest('[data-gallery-step]');
 if(!thumb&&!step)return;
 const track=root.querySelector('.rsbp-media');
 const slides=Array.from(track.querySelectorAll('figure'));
 let index=Math.round(track.scrollLeft/track.clientWidth);
 if(thumb){event.preventDefault();index=slides.findIndex(s=>'#'+s.id===thumb.getAttribute('href'));}
 else index=(index+Number(step.dataset.galleryStep)+slides.length)%slides.length;
 if(index>=0)track.scrollTo({left:index*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
});
function rsInitPdp(){
 document.querySelectorAll('.rsbp').forEach(root=>{
 const track=root.querySelector('.rsbp-media');
 if(!track||track.dataset.ready)return;
 track.dataset.ready='true';
 const initial=track.dataset.initialMedia;
 const firstIndex=Array.from(track.querySelectorAll('figure')).findIndex(s=>s.id.endsWith('-'+initial));
 if(firstIndex>0)track.scrollLeft=firstIndex*track.clientWidth;
 const links=Array.from(root.querySelectorAll('[data-rsbp-thumb]'));
 function sync(){const i=Math.round(track.scrollLeft/track.clientWidth);links.forEach((link,n)=>{if(n===i)link.setAttribute('aria-current','true');else link.removeAttribute('aria-current');});}
 track.addEventListener('scroll',sync,{passive:true});sync();
 });
}
rsInitPdp();document.addEventListener('shopify:section:load',rsInitPdp);
  } catch(e) { console.error(e); }
})();

})();
